var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2936_2144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03225 0.118164C12.4149 0.118164 15.9995 3.73191 15.9995 8.13126C15.9995 12.5437 12.3888 16.1182 7.95376 16.1182C3.57109 16.1051 -0.0135352 12.5044 -0.000452585 8.10507C0.01263 3.67954 3.58418 0.118164 8.03225 0.118164ZM1.22931 8.11816C1.22931 11.8236 4.26447 14.8743 7.95376 14.8874C11.7085 14.9005 14.7567 11.8759 14.7698 8.14435C14.7829 4.39967 11.7477 1.36203 8.00609 1.34893C4.26447 1.33584 1.22931 4.37348 1.22931 8.11816Z",
    fill: "#FE273B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0547 5.17287C5.26046 4.96712 5.59404 4.96712 5.7998 5.17287L8 7.37307L10.2002 5.17287C10.406 4.96712 10.7395 4.96712 10.9453 5.17287C11.151 5.37862 11.151 5.71221 10.9453 5.91796L8.74509 8.11816L10.9453 10.3184C11.151 10.5241 11.151 10.8577 10.9453 11.0635C10.7395 11.2692 10.406 11.2692 10.2002 11.0635L8 8.86326L5.7998 11.0635C5.59404 11.2692 5.26046 11.2692 5.0547 11.0635C4.84895 10.8577 4.84895 10.5241 5.0547 10.3184L7.25491 8.11816L5.0547 5.91796C4.84895 5.71221 4.84895 5.37862 5.0547 5.17287Z",
    fill: "#FE273B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_2144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.118164)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.70755181c923dbe0c5ab3d1b1b58f49c.svg";
export { ForwardRef as ReactComponent };